import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star, ShieldCheck, CalendarCheck } from 'lucide-react';
import { stats } from '../data/site';
const badges = [{
  icon: ShieldCheck,
  label: 'Licensed & insured'
}, {
  icon: CalendarCheck,
  label: 'Same-day quotes'
}, {
  icon: Star,
  label: '4.9 average rating'
}];
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-[#FFFDF6]" data-id="element-55" data-mp="4jvv38zjv4v7">
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#7FD8FF]/40 blur-2xl" data-id="element-56" data-mp="128yzydv6bxz6" />
      <div className="relative mx-auto grid w-full max-w-7xl gap-12 px-5 pb-16 pt-14 sm:px-8 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-16 lg:pb-24 lg:pt-20" data-id="element-57" data-mp="sarsclmrys9u">
        <div data-id="element-58" data-mp="nekl8pin7aqb">
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} className="inline-flex items-center gap-2 rounded-full border-2 border-[#0B1B2B] bg-white px-4 py-1.5 text-xs font-extrabold uppercase tracking-[0.16em] text-[#0B1B2B]" data-id="element-59" data-mp="3d1a8hk3o4bda">
            <span className="h-2 w-2 rounded-full bg-[#16A34A]" aria-hidden="true" data-id="element-60" data-mp="3o6aru18b2h2l" />
            Now booking this week
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.05
        }} className="mt-6 text-[2.75rem] font-black leading-[0.95] tracking-tight text-[#0B1B2B] sm:text-6xl lg:text-7xl" data-id="element-61" data-mp="39cpfz2rm3z6l">
            Glass so clean
            <br data-id="element-62" data-mp="2qkdaw89kqjsr" />
            it looks like
            <span className="relative ml-3 inline-block" data-id="element-63" data-mp="2qloh0eqhs3n1">
              <span className="relative z-10" data-id="element-64" data-mp="2vi54d6pvadz2">nothing</span>
              <span aria-hidden="true" className="absolute inset-x-[-6px] bottom-1 z-0 h-4 -rotate-1 rounded-sm bg-[#FFD84D] sm:h-6" data-id="element-65" data-mp="2vglm5aknhsun" />
            </span>
            .
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.12
        }} className="mt-6 max-w-xl text-lg leading-relaxed text-[#0B1B2B]/75 sm:text-xl" data-id="element-66" data-mp="s2jj7lrcvge8">
            Horizons is a professional window cleaning crew for homes and storefronts.
            Flat pricing, careful hands, and a streak-free finish we guarantee in writing.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.18
        }} className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-67" data-mp="1ayjh1d70le5q">
            <a href="#quote" className="group inline-flex items-center justify-center gap-2 rounded-full border-2 border-[#0B1B2B] bg-[#0B1B2B] px-7 py-4 text-base font-extrabold text-[#FFFDF6] shadow-[5px_5px_0_0_#FFD84D] transition hover:-translate-y-0.5 hover:shadow-[7px_7px_0_0_#FFD84D]" data-id="element-68" data-mp="x0cqki4eagg3">
              Get my free quote
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-69" data-mp="21aeirgr7ylam" />
            </a>
            <a href="#services" className="inline-flex items-center justify-center rounded-full border-2 border-[#0B1B2B] bg-white px-7 py-4 text-base font-extrabold text-[#0B1B2B] transition hover:bg-[#0B1B2B]/5" data-id="element-70" data-mp="26868q58azxc6">
              See what we clean
            </a>
          </motion.div>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-71" data-mp="2ozz589ml00on">
            {badges.map(badge => <li key={badge.label} className="flex items-center gap-2 text-sm font-bold text-[#0B1B2B]/70" data-id="element-72" data-mp="2u03kjwbr6pda">
                <badge.icon className="h-4 w-4 text-[#0B1B2B]" aria-hidden="true" data-id="element-73" data-mp="uokebphu3v7b" />
                {badge.label}
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="relative" data-id="element-74" data-mp="49t31sfpgurt">
          <div className="overflow-hidden rounded-[2rem] border-4 border-[#0B1B2B] shadow-[10px_10px_0_0_#0B1B2B]" data-id="element-75" data-mp="e91w8j2qy5d4">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/2f87e585-1597-4b22-8685-95c8ce969896.jpg" alt="Modern home with large, freshly cleaned windows reflecting a blue sky" className="h-full w-full object-cover" loading="eager" data-id="element-76" data-mp="98e2hpn4vaf7" />
          </div>
          <div className="absolute -bottom-6 left-4 hidden rounded-2xl border-4 border-[#0B1B2B] bg-[#FFD84D] px-5 py-3 shadow-[6px_6px_0_0_#0B1B2B] sm:block" data-id="element-77" data-mp="3motuyox7nqtc">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-[#0B1B2B]/70" data-id="element-78" data-mp="2yxogoe6x56l5">
              Guarantee
            </p>
            <p className="text-lg font-black leading-tight text-[#0B1B2B]" data-id="element-79" data-mp="19i5defgpt2fk">
              Streaks? We redo it free.
            </p>
          </div>
        </motion.div>
      </div>

      <div className="border-y-4 border-[#0B1B2B] bg-[#0B1B2B]" data-id="element-80" data-mp="zkhkzw6l070k">
        <dl className="mx-auto grid w-full max-w-7xl grid-cols-2 divide-x-2 divide-[#FFFDF6]/15 px-5 sm:px-8 lg:grid-cols-4" data-id="element-81" data-mp="zmarnbh72r8k">
          {stats.map(stat => <div key={stat.label} className="px-2 py-6 text-center lg:py-8" data-id="element-82" data-mp="1s8vhu8lxoxaj">
              <dt className="sr-only" data-id="element-83" data-mp="1x7zr0z8uyv0v">{stat.label}</dt>
              <dd data-id="element-84" data-mp="1x7q11bntcnv6">
                <span className="block text-3xl font-black text-[#FFD84D] lg:text-4xl" data-id="element-85" data-mp="1x65di5zx256t">
                  {stat.value}
                </span>
                <span className="mt-1 block text-xs font-bold uppercase tracking-[0.16em] text-[#FFFDF6]/70" data-id="element-86" data-mp="1n9ajo0el8syv">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}